<template>
    <div style="width: 100%; height: 100%; text-align: left;">
        <v-treeview
                :search="search"
                item-text="itemText"
                open-all
                :activatable="false"
                :dense="true"
                :hoverable="true"
                :items="itemsSafe"
                :open-on-click="true"
                :rounded="true"
                :selectable="false"
                @input="val=>this.itemModel=val"
                @update:active="val=>this.itemActive=val"
                @update:open="val=>this.itemOpen=val"
        >
            <template #label="{ item }">
                <template v-if="item.deleted()">
                    <span style="color: #ddd">{{item.manual.title}} [{{item.name}}]</span>

                    <v-tooltip top>
                        <template v-slot:activator="{on}">
                            <v-btn v-on="on" @click.stop="$emit('click:restore', item)" icon>
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                        </template>
                        복구하기
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{on}">
                            <v-btn v-on="on" @click.stop="$emit('click:delete-permanently', item)" icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        영구삭제하기
                    </v-tooltip>
                </template>
                <template v-else>
                    <v-tooltip top v-if="item.isNew">
                        <template v-slot:activator="{on}">
                            <v-badge
                                    color="yellow accent-4"
                                    icon="mdi-exclamation"
                            >
                                <span v-on="on">{{item.manual.title}} [{{item.name}}]</span>
                            </v-badge>
                        </template>
                        <div style="max-width: 300px;">새로 생긴 매뉴얼입니다.<br>사용자에게 노출되지 않습니다.</div>
                    </v-tooltip>
                    <v-tooltip top v-else-if="item.isClosed">
                        <template v-slot:activator="{on}">
                            <v-badge
                                    color="red accent-4"
                                    icon="mdi-close"
                            >
                                <span v-on="on">{{item.manual.title}} [{{item.name}}]</span>
                            </v-badge>
                        </template>
                        <div style="max-width: 300px;">비활성화 처리된 매뉴얼입니다.<br>사용자에게 노출되지 않습니다.</div>
                    </v-tooltip>
                    <span v-else>{{item.manual.title}} [{{item.name}}]</span>

                    <manual-append-button
                            v-if="item.isNode"
                            :item="item"
                            :sort="sort"
                    >
                    </manual-append-button>

                    <manual-edit-button
                            :item="item"
                    >
                    </manual-edit-button>

                    <v-tooltip top>
                        <template v-slot:activator="{on}">
                            <v-btn v-on="on" @click.stop="$emit('click:delete', item)" icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        플래그로 삭제처리하기
                    </v-tooltip>

                    <v-tooltip top v-if="item.isBook">
                        <template v-slot:activator="{on}">
                            <v-btn
                                    v-on="on"
                                    icon @click.stop="$emit('click:manage-item', item)">
                                <v-icon>mdi-format-list-bulleted-square</v-icon>
                            </v-btn>
                        </template>
                        항목 관리로 이동
                    </v-tooltip>

                    <v-tooltip top v-if="(item.isNew || item.isClosed)">
                        <template v-slot:activator="{on}">
                            <v-btn
                                    v-on="on"
                                    icon
                                    @click.stop="$emit('click:activate', item)"
                            >
                                <v-icon color="success">mdi-progress-check</v-icon>
                            </v-btn>
                        </template>
                        활성화하기
                    </v-tooltip>

                    <v-tooltip top v-else>
                        <template v-slot:activator="{on}">
                            <v-btn
                                    v-on="on"
                                    icon
                                    @click.stop="$emit('click:close', item)"
                            >
                                <v-icon>mdi-progress-check</v-icon>
                            </v-btn>
                        </template>
                        비활성화하기
                    </v-tooltip>
                </template>
            </template>
        </v-treeview>
    </div>
</template>

<script>
    import ManualAppendButton from "@/views/manual/manage/ManualAppendButton";
    import ManualEditButton from "@/views/manual/manage/ManualEditButton";

    export default {
        name: "ManualTreeView",
        components: {ManualEditButton, ManualAppendButton},
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            search: {
                type: String,
                default: "",
            },
            sort: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                itemModel: undefined,
                itemActive: undefined,
                itemOpen: undefined,
            }
        },
        computed: {
            itemsSafe() {
                return this.items || {};
            },
        },
    }
</script>

<style scoped>
    >>> .v-treeview-node__label {
        overflow: visible !important;
    }
</style>